import { CustomDialog } from "../../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { useStockCycleDatasValueContextHook } from "../../../../contexts/StockCycleDatasContext";
import { STOCK_CYCLE_DATA_SERVICE } from "../../../../service/stockCycleDataService";
import { ANALYSIS_VERSIONS } from "../../../../variables/analysisVersions";
import { useSettingVariablesValueContextHook } from "../../../../contexts/SettingVariablesContext";
import { CustomRatioImage } from "../../../../../../../components/image/CustomRatioImage";
import { Link } from "react-router-dom";
import CustomBlockButton from "../../../../../../../components/button/CustomBlockButton";
import { useEffect, useState } from "react";
import { ModalViewMemo } from "../modal-view-memo";
import { useApiInfoContextValueHook } from "../../../../../../../contexts/ApiInfoContext";
import { SellertoolSignatureUtils } from "../../../../../../../utils/sellertool-signature-utils";
import { CustomBackdropController } from "../../../../../../../components/backdrop/default/v1";
import { AnalyticsApi } from "../../../../../../../apis/AnalyticsApi";
import { FragmentOrderUnitGraph } from "./fragments/fragment-order-unit-graph";

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;
`;

const TableContainer = styled.div`
  overflow-x: auto;
  margin: 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 100%;
  max-height: 300px;
  border: 1px solid #efefef;
`

const StyledTable = styled.table`
  table-layout: auto;    /* 내용 길이에 맞춰 열 너비 자동 */
  white-space: nowrap;   /* 한 줄로 표시하여 열이 자동 확장 */
  border-collapse: collapse;
  background-color: #ffffff;

  /* width: 100%;  <-- 필요한 경우 제거하거나 조정
     min-width: 800px; <-- 원한다면 유지 (너무 좁아지지 않게)
  */
`;

const TableHeader = styled.thead`
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f8f9fa;
`

const TableHeaderCell = styled.th`
    padding: 16px;
    text-align: left;
    font-weight: 600;
    color: #495057;
    border-bottom: 2px solid #dee2e6;
    white-space: nowrap;
    font-size: 14px;
`

const TableRow = styled.tr`
    &.selected{
        background-color: #e2f0d9 !important;
    }

    &:nth-child(even) {
        background-color: #f8f9fa;
    }

    &:hover {
        background-color: #e9ecef;
    }
`

const TableCell = styled.td`
  padding: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;
  font-size: 12px;
  font-weight: 600;

  .thumbnail{
    width: 30px;
    height: 30px;
  }

  .danger-badge{
    display: inline-block;
    margin-top: 4px;
    background-color: var(--redColor1);
    color: white;
    padding: 2px 4px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 600;
  }

  .view-memo-button{
    width: fit-content;
    padding: 0 16px;
    height: 30px;
    border-radius: 3px;
    font-size: 12px;
    background-color: #333;
    color:#fff;
    font-weight: 700;
    border:none;
  }
`;

export function ModalViewProductAnalytics({
    open,
    onClose,
    requestProductOptionDetail
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const settingVariablesValueContextHook = useSettingVariablesValueContextHook();
    const settingVariables = settingVariablesValueContextHook.settingVariables;

    const stockCycleDatasValueContextHook = useStockCycleDatasValueContextHook();
    const stockCycleDatas = stockCycleDatasValueContextHook.stockCycleDatas;
    const productOptionsDetailList = stockCycleDatas?.productOptionsDetailList;
    const isV3 = stockCycleDatas?.analysisVersion === ANALYSIS_VERSIONS.V3;

    const [orders, setOrders] = useState(null);

    const [viewMemoModalOpen, setViewMemoModalOpen] = useState(false);
    const [targetProductOptionDetail, setTargetProductOptionDetail] = useState(null);
    const [selectedProductOptionDetail, setSelectedProductOptionDetail] = useState(null);

    const analyticsProductOptionsDetailList = productOptionsDetailList?.filter((item) => {
        return item?.productDto?.id === requestProductOptionDetail?.productDto?.id
    });
    const productOptionIdsStr = analyticsProductOptionsDetailList?.map((item) => item?.productOptionId)?.join(',');

    useEffect(() => {
        if (!apiInfoContextValueHook?.apiInfo?.apiKey || !apiInfoContextValueHook?.apiInfo?.secretKey || !productOptionIdsStr) {
            return;
        }
        handleFetchOrders();
    }, [
        apiInfoContextValueHook?.apiInfo?.apiKey,
        apiInfoContextValueHook?.apiInfo?.secretKey,
        productOptionIdsStr
    ]);

    const handleFetchOrders = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();
        const response = await AnalyticsApi().searchOrders({
            headers: headers,
            params: {
                releaseFrom: settingVariables?.releaseFrom,
                releaseTo: settingVariables?.releaseTo,
                productOptionIds: productOptionIdsStr,
            }
        });

        if (response?.content) {
            setOrders(response?.content);
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleViewMemoModalOpen = (productOptionDetail) => {
        setTargetProductOptionDetail(productOptionDetail);
        setViewMemoModalOpen(true);
    }

    const handleViewMemoModalClose = () => {
        setTargetProductOptionDetail(null);
        setViewMemoModalOpen(false);
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
                maxWidth="xl"
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            상품분석
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close
                            onClick={onClose}
                        />
                    </CustomDialog.Header>
                </StyledHeader>
                <StyledBody>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                        <TableContainer>
                            <StyledTable>
                                <TableHeader>
                                    <tr>
                                        <TableHeaderCell>상품이미지</TableHeaderCell>
                                        <TableHeaderCell>상품정보</TableHeaderCell>
                                        <TableHeaderCell>옵션코드</TableHeaderCell>
                                        <TableHeaderCell>재고수량</TableHeaderCell>
                                        <TableHeaderCell>기간내 주문량 / {isV3 ? '보정' : 'IQR'}</TableHeaderCell>
                                        <TableHeaderCell>일평균 주문량 / {isV3 ? '보정' : 'IQR'}</TableHeaderCell>
                                        <TableHeaderCell>출고가능기간</TableHeaderCell>
                                        <TableHeaderCell>추천구매수량</TableHeaderCell>
                                        <TableHeaderCell>구매URL</TableHeaderCell>
                                        <TableHeaderCell>메모</TableHeaderCell>
                                    </tr>
                                </TableHeader>
                                <tbody>
                                    {analyticsProductOptionsDetailList?.filter(productOptionDetail => {
                                        if (settingVariables?.hideNoOrderFlag) {
                                            return productOptionDetail?.iqrData?.releaseQty > 0;
                                        }
                                        return true;
                                    })?.filter(productOptionDetail => {
                                        if (settingVariables?.viewOnlyUnderLeadTimeFlag) {
                                            const daysOfCanRelease = getDaysOfCanRelease({
                                                stockQty: productOptionDetail?.inventoryStockDto?.stockUnit,
                                                releaseQtyPerDay: productOptionDetail?.iqrData?.releaseQtyPerDay
                                            });
                                            return daysOfCanRelease < settingVariables.daysOfLeadTime;
                                        }
                                        return true;
                                    })?.map((productOptionDetail, rowIndex) => {
                                        const daysOfCanRelease = getDaysOfCanRelease({
                                            stockQty: productOptionDetail?.inventoryStockDto?.stockUnit,
                                            releaseQtyPerDay: productOptionDetail?.iqrData?.releaseQtyPerDay
                                        });
                                        const weeksOfCanRelease = Math.floor(daysOfCanRelease / 7);
                                        const recommendPurchaseQty = getRecommendPurchaseQty({
                                            stockQty: productOptionDetail?.inventoryStockDto?.stockUnit,
                                            releaseQtyPerDay: productOptionDetail?.iqrData?.releaseQtyPerDay,
                                            targetDOS: settingVariables.targetDOS,
                                            daysOfLeadTime: settingVariables.daysOfLeadTime
                                        });

                                        return (
                                            <TableRow
                                                key={rowIndex}
                                                onClick={() => setSelectedProductOptionDetail(prev => prev?.productOptionId === productOptionDetail?.productOptionDto?.id ? null : productOptionDetail)}
                                                className={selectedProductOptionDetail?.productOptionId === productOptionDetail?.productOptionId ? 'selected' : ''}
                                            >
                                                <TableCell>
                                                    <div className='thumbnail'>
                                                        <CustomRatioImage>
                                                            <CustomRatioImage.Image src={productOptionDetail?.productDto?.thumbnailUri} />
                                                        </CustomRatioImage>
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    <div>{productOptionDetail?.productDto?.name} [{productOptionDetail?.productDto?.productTag}]</div>
                                                    <div>{productOptionDetail?.productOptionDto?.name} [{productOptionDetail?.productOptionDto?.productTag}]</div>
                                                </TableCell>
                                                <TableCell>{productOptionDetail?.productOptionDto?.code}</TableCell>
                                                <TableCell>
                                                    {productOptionDetail?.inventoryStockDto?.stockUnit <= 0 ?
                                                        <span style={{ color: 'var(--redColor1)' }}>{productOptionDetail?.inventoryStockDto?.stockUnit}</span>
                                                        :
                                                        <span>{productOptionDetail?.inventoryStockDto?.stockUnit}</span>
                                                    }
                                                </TableCell>
                                                <TableCell><span style={{ color: '#808080', fontWeight: '500' }}>{productOptionDetail?.releaseQty}</span> / <span style={{ color: 'var(--blueColor1)', fontWeight: '800' }}>{productOptionDetail?.iqrData?.releaseQty}</span></TableCell>
                                                <TableCell><span style={{ color: '#808080', fontWeight: '500' }}>{productOptionDetail?.releaseQtyPerDay}</span> / <span style={{ color: 'var(--blueColor1)', fontWeight: '800' }}>{productOptionDetail?.iqrData?.releaseQtyPerDay}</span></TableCell>
                                                <TableCell>
                                                    <div>{daysOfCanRelease}일 / {weeksOfCanRelease}주</div>
                                                    {daysOfCanRelease < (settingVariables.daysOfLeadTime) ?
                                                        <span className='danger-badge'>위험</span>
                                                        :
                                                        <></>
                                                    }
                                                </TableCell>
                                                <TableCell>
                                                    {recommendPurchaseQty > 0 ?
                                                        <span style={{ color: 'var(--greenColor1)' }}>{recommendPurchaseQty}</span>
                                                        :
                                                        <span>0</span>
                                                    }
                                                </TableCell>
                                                <TableCell>
                                                    {productOptionDetail?.productDto?.purchaseUri ?
                                                        <Link to={productOptionDetail?.productDto?.purchaseUri}>구매 링크</Link>
                                                        :
                                                        <span style={{ color: '#a0a0a0' }}>미등록</span>
                                                    }
                                                </TableCell>
                                                <TableCell>
                                                    <CustomBlockButton
                                                        type='button'
                                                        className='view-memo-button'
                                                        onClick={(e) => { e.stopPropagation(); handleViewMemoModalOpen(productOptionDetail); }}
                                                    >
                                                        보기
                                                    </CustomBlockButton>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    }
                                    )}
                                </tbody>
                            </StyledTable>
                        </TableContainer>
                        <TableContainer style={{ width: '400px' }}>
                            <StyledTable>
                                <TableHeader>
                                    <tr>
                                        <TableHeaderCell>주문번호</TableHeaderCell>
                                        <TableHeaderCell>출고수량</TableHeaderCell>
                                        <TableHeaderCell>수취인명</TableHeaderCell>
                                    </tr>
                                </TableHeader>
                                <tbody>
                                    {orders?.filter(order => order?.productOptionId === selectedProductOptionDetail?.productOptionId)?.map((order, rowIndex) => {
                                        const iqrData = selectedProductOptionDetail?.iqrData;
                                        // V3 는 서버가 제외한 주문건 목록을 기준으로 판단한다. (표본 부족으로 판정을 건너뛴 경우도 있어 상한 비교만으로는 알 수 없다)
                                        const isFiltered = STOCK_CYCLE_DATA_SERVICE.isOutlierOrder(selectedProductOptionDetail, order);
                                        return (
                                            <TableRow
                                                key={rowIndex}
                                                style={{
                                                    backgroundColor: isFiltered ? 'var(--redColor1)' : '',
                                                    opacity: isFiltered ? 0.7 : 1,
                                                }}
                                            >
                                                <TableCell>{order?.orderNumber1}</TableCell>
                                                <TableCell>{isFiltered ? <><s>{order?.releaseQty}</s> ▶️ {isV3 ? '제외' : iqrData?.upperBound}</> : <>{order?.releaseQty}</>}</TableCell>
                                                <TableCell>{order?.receiver}</TableCell>
                                            </TableRow>
                                        );
                                    }
                                    )}
                                </tbody>
                            </StyledTable>
                        </TableContainer>
                    </div>
                    <FragmentOrderUnitGraph
                        analyticsProductOptionsDetailList={analyticsProductOptionsDetailList}
                        releaseFrom={settingVariables?.releaseFrom}
                        releaseTo={settingVariables?.releaseTo}
                        apiKey={apiInfoContextValueHook?.apiInfo?.apiKey}
                        secretKey={apiInfoContextValueHook?.apiInfo?.secretKey}
                    />
                </StyledBody>
            </CustomDialog>

            {(viewMemoModalOpen && targetProductOptionDetail) &&
                <ModalViewMemo
                    open={viewMemoModalOpen}
                    onClose={handleViewMemoModalClose}
                    productOptionDetail={targetProductOptionDetail}
                />
            }
        </>
    );
}

function getDaysOfCanRelease({ stockQty, releaseQtyPerDay }) {
    if (stockQty <= 0 || releaseQtyPerDay <= 0) {
        return 0;
    }
    return Math.floor(stockQty / releaseQtyPerDay);
}

function getRecommendPurchaseQty({
    stockQty,
    releaseQtyPerDay,
    targetDOS,
    daysOfLeadTime
}) {
    let newStockQty = stockQty;
    let newReleaseQtyPerDay = releaseQtyPerDay;
    if (stockQty <= 0) {
        newStockQty = 0;
    }
    if (releaseQtyPerDay <= 0) {
        newReleaseQtyPerDay = 0;
    }

    const recommendPurchaseQty = ((Number(targetDOS) + Number(daysOfLeadTime)) * Number(newReleaseQtyPerDay)) - Number(newStockQty);

    return recommendPurchaseQty > 0 ? recommendPurchaseQty.toFixed(2) : 0;
}